import { Injectable } from "@angular/core";
import { ToastrService } from 'ngx-toastr';


@Injectable({
    providedIn: 'root'
  })
export class ToasterServices{
    constructor(private toastr: ToastrService) { }
    showWarnToast(title:string,message:string,timeLimit){
        this.toastr.warning(message,title,{
            closeButton:true,
            timeOut:timeLimit

        });
    }
    showErrToast(title:string,message:string){
        this.toastr.error(message,title,{
            closeButton:true,
        });
    }
    showSuccessToast(title:string,message:string,timeLimit){
        this.toastr.success(message,title,{
            closeButton:true,
            timeOut:timeLimit
        });}
}